module.exports = __webpack_public_path__ + "img/Payment-Bizum.2fdaa1db.jpg";